$(document).ready(function() {
    let $headerSectionSelectors = $('.header-section, .header-section__helper');

    $(window).scroll(function() {
        $(window).scrollTop() > 34 
        ? $headerSectionSelectors.addClass('active')
        : $headerSectionSelectors.removeClass('active')
    });

    // var stickyEl = new Sticksy('.header-section__wrapper', {topSpacing: 60})
    // stickyEl.onStateChanged = function (state) {
    //     if(state === 'fixed') stickyEl.nodeRef.classList.add('widget--sticky')
    //     else stickyEl.nodeRef.classList.remove('widget--sticky')
    // }

    // var sticky = new Sticky('.header-section');

    
});